<template lang="pug">
.custom-bumper(ref='custom-render')
  custom-bumper-render-fonts(ref="customFonts")
  //-
    The 2d mode overlays the svg on a flat png of the bumper. The DynamicMedia will be the bumper image (set in productStore.ts)
    and the `.view-svg` will be updated with the template contents on changes.
  .fallback(v-if="renderType === '2d'")
    DynamicMedia#customBumper(:config="staticImgConfig" contain)
      .view-container
        svg.view-svg(xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox="0 0 1288.8 1288.8" ref="viewSvg" width="1288.8px" height="1288.8px")
  //-
    In 3d mode we will render to an HTML canvas using WebGL
  .canvas(v-else)
    canvas(ref="threeCanvas")
  //-
    The template is used to create the face of the bumper.
    It is primarily modified using javascript - not vue reactivity - because it needs to be updated synchronously before
    rendering it to a canvas or copying it
  client-only
    svg.template(xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox="0 0 1288.8 1288.8" ref="svg" :class="debug && 'debug'" :data-weight="weight")
      defs
        camo-pattern(:id="id")
        tek-pattern(:id="id")
        //- Text path arc - we will use this for rendering custom text around at an angle
        path#custom-text-path(ref="textPath" :d="sku === 'IP0535-CST-Group' ? 'M 250 488 A 433 433 0 0 1 1043 488': 'M 216 488 A 455 455 0 0 1 1072 488'" stroke="blue" stroke-width="50")
        // - Text path circle to allow text to grow without being clipped by browsers, solving computedTextLength differences between chrome and safari
        path#custom-text-path-circle(d="M189,644a455,455 0 1,0 910,0a455,455 0 1,0 -910,0" stroke="blue" stroke-width="50")
      //- Main render contents - all affected by the same fill color, which is coming from the configuration
      g#contents(:style='{fill:color}')
        g#upper-rogue(v-if="config.type === 'design' && showRogueLogo" :transform="`translate(0, ${sku === 'IP0535-CST-Group' ? 30 : -20})`")
          path(d='M421.73,250.5c9.8,26.7,29.1,34.8,57.9,24.2,28.9-10.6,38.6-29.1,28.9-55.5-9.7-26.5-29-34.5-57.9-23.9-14.5,5.3-24.1,12.8-29,22.5-4.5,9.3-4.4,20.2,.1,32.7m21.4-74.7c24.5-9,44.6-12,60.3-9,19.6,3.6,33.5,16.5,41.7,38.8,14.5,39.5-4.9,69-58.1,88.4-27.2,10-49.2,12.4-65.8,7.3-16.6-5.1-28.6-17.7-35.9-37.6-14.4-39.2,4.9-68.5,57.8-87.9')
          path(d='M681.53,237.5l.8-28.3-47.4-1.4,.6-21.4,83.8,2.5-2.1,71.8-76.5-2.3c-53.5-1.6-79.7-21.8-78.5-60.7,.7-22.5,8.3-38.6,22.9-48.4,13.3-8.8,33.1-12.9,59.2-12.1l76.5,2.3-.6,21.1-76.5-2.3c-12.8-.4-22.4,2-28.9,7.2-7.8,6.2-12,16.9-12.4,32-.4,12.5,2.2,21.8,7.6,27.9,6.1,6.8,16.6,10.4,31.4,10.9l40.1,1.2Z')
          path(d='M744.13,211.4l29.1-67.5,32.8,14.2-28.9,66.9c-4.1,9.4-5.1,16.9-3,22.4,2.9,7.5,11.6,14.4,26.2,20.7,12.4,5.3,21.8,7.3,28.4,5.8,7.6-1.6,13.7-7.9,18.4-18.7l28.9-66.9,32.5,14-29.1,67.5c-6.7,15.5-15.4,24.7-26.1,27.7-13.4,3.9-33.6,0-60.6-11.6-26.4-11.4-43-23.2-49.7-35.4-6-10.5-5.6-23.5,1.1-39.1')
          path#c(d='M1052.93,335.2l.7,.7c.9,.8,1.9,1.3,2.6,.5,.6-.6,.6-1.5-.4-2.5-.4-.4-.7-.7-1-.8l-1.9,2.1Zm-3.7,3.7l-1.6-1.5,6.6-6.8c.7,.5,1.7,1.2,2.8,2.3,1.3,1.3,1.7,2,1.8,2.8,.1,.7-.1,1.5-.7,2.1-.8,.8-2,.8-3,.2l-.1,.1c.5,.9,.3,1.7-.4,2.8-.8,1.2-1,1.8-1.1,2.1l-1.7-1.6c0-.5,.5-1.2,1.1-2.2,.6-.8,.5-1.6-.4-2.4l-.7-.7-2.6,2.8Zm-.8-7.6c-3,3-3,7.7,0,10.6,2.9,2.9,7.5,2.7,10.5-.3s3.1-7.7,.1-10.6c-3-2.9-7.6-2.7-10.6,.3m12.3,12c-3.7,3.8-9.8,3.8-13.7,0s-4.1-9.9-.3-13.7c3.7-3.8,9.8-3.8,13.7,.1,3.8,3.8,4,9.8,.3,13.6')
          path(d='M1048.13,315.7l-14.4,15.4-42.7-40c-18.3-17.1-34.5-19.4-48.7-6.8l72,67.5-14.4,15.4-72-67.5c-7.3,7.8-10.2,15.5-8.6,23.2s7.4,16.3,17.6,25.9l42.7,40-14.4,15.4-43.8-41.1c-38.6-36.1-44.5-68.4-17.9-96.8,13.7-14.6,28.1-21.8,43.3-21.6,17.5,.4,36.9,10.6,58.3,30.6l43,40.4Z')
          path(d='M299.03,300.1l-30.9,30.8,21.7,21.7,30.9-30.8c8.4-8.4,13.5-15,15.3-19.9,1.8-4.8,.5-9.4-3.7-13.6-3.6-3.6-6.9-5.1-9.9-4.7-5.5,.9-13.3,6.4-23.4,16.5m39.3,101.3l-25.2,25.1-85.6-85.9,62-61.8c14.3-14.3,27-22.8,37.9-25.6,10.9-2.8,21,.4,30.1,9.5,6.2,6.2,9.4,13.3,9.5,21.2,.1,8.6-3.1,17.5-9.7,26.8l65.5,6.5-28.2,28.1-60.1-7-29.6,29.5,33.4,33.6Z')
        //-
          This custom image group will be updated with another SVG. The group's transform moves it to the right place,
          and the viewbox on the embedded SVG will center it and make sure it fills the area.
          This is where we could add the clipPath if we wanted.
        g#custom-image(v-if="config.type !== 'text'" ref="customImage")
          path(d='M421.73,250.5c9.8,26.7,29.1,34.8,57.9,24.2,28.9-10.6,38.6-29.1,28.9-55.5-9.7-26.5-29-34.5-57.9-23.9-14.5,5.3-24.1,12.8-29,22.5-4.5,9.3-4.4,20.2,.1,32.7m21.4-74.7c24.5-9,44.6-12,60.3-9,19.6,3.6,33.5,16.5,41.7,38.8,14.5,39.5-4.9,69-58.1,88.4-27.2,10-49.2,12.4-65.8,7.3-16.6-5.1-28.6-17.7-35.9-37.6-14.4-39.2,4.9-68.5,57.8-87.9')
          path(d='M681.53,237.5l.8-28.3-47.4-1.4,.6-21.4,83.8,2.5-2.1,71.8-76.5-2.3c-53.5-1.6-79.7-21.8-78.5-60.7,.7-22.5,8.3-38.6,22.9-48.4,13.3-8.8,33.1-12.9,59.2-12.1l76.5,2.3-.6,21.1-76.5-2.3c-12.8-.4-22.4,2-28.9,7.2-7.8,6.2-12,16.9-12.4,32-.4,12.5,2.2,21.8,7.6,27.9,6.1,6.8,16.6,10.4,31.4,10.9l40.1,1.2Z')
          path(d='M744.13,211.4l29.1-67.5,32.8,14.2-28.9,66.9c-4.1,9.4-5.1,16.9-3,22.4,2.9,7.5,11.6,14.4,26.2,20.7,12.4,5.3,21.8,7.3,28.4,5.8,7.6-1.6,13.7-7.9,18.4-18.7l28.9-66.9,32.5,14-29.1,67.5c-6.7,15.5-15.4,24.7-26.1,27.7-13.4,3.9-33.6,0-60.6-11.6-26.4-11.4-43-23.2-49.7-35.4-6-10.5-5.6-23.5,1.1-39.1')
          path#c(d='M1052.93,335.2l.7,.7c.9,.8,1.9,1.3,2.6,.5,.6-.6,.6-1.5-.4-2.5-.4-.4-.7-.7-1-.8l-1.9,2.1Zm-3.7,3.7l-1.6-1.5,6.6-6.8c.7,.5,1.7,1.2,2.8,2.3,1.3,1.3,1.7,2,1.8,2.8,.1,.7-.1,1.5-.7,2.1-.8,.8-2,.8-3,.2l-.1,.1c.5,.9,.3,1.7-.4,2.8-.8,1.2-1,1.8-1.1,2.1l-1.7-1.6c0-.5,.5-1.2,1.1-2.2,.6-.8,.5-1.6-.4-2.4l-.7-.7-2.6,2.8Zm-.8-7.6c-3,3-3,7.7,0,10.6,2.9,2.9,7.5,2.7,10.5-.3s3.1-7.7,.1-10.6c-3-2.9-7.6-2.7-10.6,.3m12.3,12c-3.7,3.8-9.8,3.8-13.7,0-3.9-3.8-4.1-9.9-.3-13.7,3.7-3.8,9.8-3.8,13.7,.1,3.8,3.8,4,9.8,.3,13.6')
          path(d='M1048.13,315.7l-14.4,15.4-42.7-40c-18.3-17.1-34.5-19.4-48.7-6.8l72,67.5-14.4,15.4-72-67.5c-7.3,7.8-10.2,15.5-8.6,23.2s7.4,16.3,17.6,25.9l42.7,40-14.4,15.4-43.8-41.1c-38.6-36.1-44.5-68.4-17.9-96.8,13.7-14.6,28.1-21.8,43.3-21.6,17.5,.4,36.9,10.6,58.3,30.6l43,40.4Z')
          path(d='M299.03,300.1l-30.9,30.8,21.7,21.7,30.9-30.8c8.4-8.4,13.5-15,15.3-19.9,1.8-4.8,.5-9.4-3.7-13.6-3.6-3.6-6.9-5.1-9.9-4.7-5.5,.9-13.3,6.4-23.4,16.5m39.3,101.3l-25.2,25.1-85.6-85.9,62-61.8c14.3-14.3,27-22.8,37.9-25.6,10.9-2.8,21,.4,30.1,9.5,6.2,6.2,9.4,13.3,9.5,21.2,.1,8.6-3.1,17.5-9.7,26.8l65.5,6.5-28.2,28.1-60.1-7-29.6,29.5,33.4,33.6Z')
        //-
          Custom text, following the path.
          We use visibility here instead of a v-if because there are several computations on the element that require it
          to be visible. Using v-if was causing a race condition where the element would be hidden but the computation
          tried to run.
        text(:color='color' text-anchor='middle' :style="{visibility: config.type === 'text' ? 'visible' : 'hidden'}")
          textPath#custom-text(
            ref="customText"
            alignment-baseline='central'
            dominant-baseline='central'
            startOffset='50%'
            xlink:href="#custom-text-path-circle"
          )
        //-
          Base is the ROGUE and LB signs, which stay for every weight
          @todo split off LB so we can use this same template for KG plates as well?
        g#base.rogue-lbs(v-if='sku !== "IP0535-CST-Group"')
          path(d='M869.2,1038.16c-9.8-26.7-29.1-34.8-57.9-24.2-28.9,10.6-38.6,29.1-28.9,55.5,9.7,26.5,29,34.5,57.9,23.9,14.5-5.3,24.1-12.8,29-22.5,4.5-9.3,4.4-20.2-.1-32.7m-21.4,74.7c-24.5,9-44.6,12-60.3,9-19.6-3.6-33.5-16.5-41.7-38.8-14.5-39.5,4.9-69,58.1-88.4,27.2-10,49.2-12.4,65.8-7.3,16.6,5.1,28.6,17.7,35.9,37.6,14.4,39.2-4.9,68.5-57.8,87.9')
          path(d='M609.4,1051.16l-.8,28.3,47.4,1.4-.6,21.4-83.8-2.5,2.1-71.8,76.5,2.3c53.5,1.6,79.7,21.8,78.5,60.7-.7,22.5-8.3,38.6-22.9,48.4-13.3,8.8-33.1,12.9-59.2,12.1l-76.5-2.3,.6-21.1,76.5,2.3c12.8,.4,22.4-2,28.9-7.2,7.8-6.2,12-16.9,12.4-32,.4-12.5-2.2-21.8-7.6-27.9-6.1-6.8-16.6-10.4-31.4-10.9l-40.1-1.2Z')
          path(d='M546.8,1077.26l-29.1,67.5-32.8-14.2,28.9-66.9c4.1-9.4,5.1-16.9,3-22.4-2.9-7.5-11.6-14.4-26.2-20.7-12.4-5.3-21.8-7.3-28.4-5.8-7.6,1.6-13.7,7.9-18.4,18.7l-28.9,66.9-32.5-14,29.1-67.5c6.7-15.5,15.4-24.7,26.1-27.7,13.4-3.9,33.6,0,60.6,11.6,26.4,11.4,43,23.2,49.7,35.4,6,10.5,5.6,23.5-1.1,39.1')
          path#b(d='M238,953.46l-.7-.7c-.9-.8-1.9-1.3-2.6-.5-.6,.6-.6,1.5,.4,2.5,.4,.4,.7,.7,1,.8l1.9-2.1Zm3.7-3.7l1.6,1.5-6.6,6.8c-.7-.5-1.7-1.2-2.8-2.3-1.3-1.3-1.7-2-1.8-2.8-.1-.7,.1-1.5,.7-2.1,.8-.8,2-.8,3-.2l.1-.1c-.5-.9-.3-1.7,.4-2.8,.8-1.2,1-1.8,1.1-2.1l1.7,1.6c0,.5-.5,1.2-1.1,2.2-.6,.8-.5,1.6,.4,2.4l.7,.7,2.6-2.8Zm.8,7.6c3-3,3-7.7,0-10.6-2.9-2.9-7.5-2.7-10.5,.3s-3.1,7.7-.1,10.6c3,2.9,7.6,2.7,10.6-.3m-12.3-12c3.7-3.8,9.8-3.8,13.7,0,3.9,3.8,4.1,9.9,.3,13.7-3.7,3.8-9.8,3.8-13.7-.1-3.8-3.8-4-9.8-.3-13.6')
          path(d='M242.8,972.96l14.4-15.4,42.7,40c18.3,17.1,34.5,19.4,48.7,6.8l-72-67.5,14.4-15.4,72,67.5c7.3-7.8,10.2-15.5,8.6-23.2s-7.4-16.3-17.6-25.9l-42.7-40,14.4-15.4,43.8,41.1c38.6,36.1,44.5,68.4,17.9,96.8-13.7,14.6-28.1,21.8-43.3,21.6-17.5-.4-36.9-10.6-58.3-30.6l-43-40.4Z')
          path(d='M991.9,988.56l30.9-30.8-21.7-21.7-30.9,30.8c-8.4,8.4-13.5,15-15.3,19.9-1.8,4.8-.5,9.4,3.7,13.6,3.6,3.6,6.9,5.1,9.9,4.7,5.5-.9,13.3-6.4,23.4-16.5m-39.3-101.3l25.2-25.1,85.6,85.9-62,61.8c-14.3,14.3-27,22.8-37.9,25.6-10.9,2.8-21-.4-30.1-9.5-6.2-6.2-9.4-13.3-9.5-21.2-.1-8.6,3.1-17.5,9.7-26.8l-65.5-6.5,28.2-28.1,60.1,7,29.6-29.5-33.4-33.6Z')
          //- left lbs
          path#d(d='M175.4,716.75v-36.1h8.4v28.8h11.5v7.3h-19.9Z')
          path(d='M209.1,709.55c3.1,0,4.1-1.3,4.1-4.1,0-3.1-1.7-4.1-4.1-4.1h-2.8v8.1l2.8,.1h0Zm-.2-14.6c2.3,0,3.6-1.1,3.6-3.8s-1.5-3.3-3.6-3.3h-2.6v7.1h2.6Zm-10.8,21.8v-36.1h10.4c8.7,0,12.6,2.9,12.6,9.5,0,3.6-1.6,6.2-4.7,7.6v.1c3.5,1.2,5.4,3.7,5.4,8.2,0,8.6-5.9,10.6-13.3,10.6h-10.4v.1Z')
          //- right lbs
          path(d='M1081.32,579.25c-3.1,0-4.1,1.3-4.1,4.1,0,3.1,1.7,4.1,4.1,4.1h2.8v-8.2h-2.8Zm.2,14.6c-2.3,0-3.6,1.1-3.6,3.8s1.5,3.3,3.6,3.3h2.6v-7.1h-2.6Zm10.9-21.8v36.1h-10.4c-8.8,0-12.6-2.9-12.6-9.6,0-3.6,1.6-6.2,4.7-7.6h0c-3.5-1.2-5.4-3.7-5.4-8.3,0-8.7,5.9-10.6,13.3-10.6h10.4Z')
          path#e(d='M1115.12,572.05v36.1h-8.4v-28.8h-11.5v-7.3h19.9Z')
          //-
            Each weight can have its own group, and only be included for the correct plate. This allows us to reuse this
            same custom-bumper-render component for multiple weights.
        g.weight(v-if="weight === 55 && sku !== 'IP0535-CST-Group'")
          path(d='M179.55,666.34h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-14.13h20.02v4.71c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-18.84c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v4.71h-20.02v-56.51h56.51v18.84h-36.5v14.13c0-2.59,2.12-4.71,4.71-4.71h17.66c7.89,0,14.13,6.36,14.13,14.13v37.68c0,7.77-6.24,14.13-14.13,14.13Z')
          path(d='M246.07,666.34h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-14.13h20.02v4.71c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-18.84c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v4.71h-20.02v-56.51h56.51v18.84h-36.5v14.13c0-2.59,2.12-4.71,4.71-4.71h17.66c7.89,0,14.13,6.36,14.13,14.13v37.68c0,7.77-6.24,14.13-14.13,14.13Z')
          path(d='M1110.96,622.55h28.26c7.77,0,14.13,6.36,14.13,14.13v14.13h-20.02v-4.71c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v18.84c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-4.71h20.02v56.51h-56.51v-18.84h36.5v-14.13c0,2.59-2.12,4.71-4.71,4.71h-17.66c-7.89,0-14.13-6.36-14.13-14.13v-37.68c0-7.77,6.24-14.13,14.13-14.13Z')
          path(d='M1044.44,622.55h28.26c7.77,0,14.13,6.36,14.13,14.13v14.13h-20.02v-4.71c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v18.84c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-4.71h20.02v56.51h-56.51v-18.84h36.5v-14.13c0,2.59-2.12,4.71-4.71,4.71h-17.66c-7.89,0-14.13-6.36-14.13-14.13v-37.68c0-7.77,6.24-14.13,14.13-14.13Z')
        g.weight(v-if="weight === 45 && sku !== 'IP0535-CST-Group'")
          path(d='M1101.42,641.39v-18.84h20.02v18.84h34.14v18.84l-20.02,56.51h-34.14v-56.51h-9.42v-18.84h9.42Zm20.02,58.75s12.36-34.97,14.83-39.91h-14.83v39.91Z')
          path(d='M1042.2,622.55h28.26c7.77,0,14.13,6.36,14.13,14.13v14.13h-20.02v-4.71c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v18.84c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-4.71h20.02v56.51h-56.51v-18.84h36.5v-14.13c0,2.59-2.12,4.71-4.71,4.71h-17.66c-7.89,0-14.13-6.36-14.13-14.13v-37.68c0-7.77,6.24-14.13,14.13-14.13Z')
          path(d='M189.18,647.4v18.84h-20.02v-18.84h-34.14v-18.84l20.02-56.51h34.14v56.51h9.42v18.84h-9.42Zm-20.02-58.75s-12.36,34.97-14.83,39.91h14.83v-39.91Z')
          path(d='M248.4,666.24h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-14.13h20.02v4.71c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-18.84c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v4.71h-20.02v-56.51h56.51v18.84h-36.5v14.13c0-2.59,2.12-4.71,4.71-4.71h17.66c7.89,0,14.13,6.36,14.13,14.13v37.68c0,7.77-6.24,14.13-14.13,14.13Z')
        g.weight(v-if="weight === 35 && sku !== 'IP0535-CST-Group'")
          path(d='M179.79,666.33h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-18.84h20.02v9.42c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-11.77c0-2.59-2-4.71-4.71-4.71h-11.77v-18.84h11.77c2.71,0,4.71-2.12,4.71-4.71v-7.06c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v7.06h-20.02v-16.48c0-7.77,6.36-14.13,14.13-14.13h28.26c7.89,0,14.13,6.36,14.13,14.13v17.31c0,6.12-3.89,11.42-9.42,13.3,5.53,1.88,9.42,7.18,9.42,13.3v22.02c0,7.77-6.24,14.13-14.13,14.13Z')
          path(d='M246.3,666.33h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-14.13h20.02v4.71c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-18.84c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v4.71h-20.02v-56.51h56.51v18.84h-36.5v14.13c0-2.59,2.12-4.71,4.71-4.71h17.66c7.89,0,14.13,6.36,14.13,14.13v37.68c0,7.77-6.24,14.13-14.13,14.13Z')
          path(d='M1110.83,622.6h28.26c7.77,0,14.13,6.36,14.13,14.13v18.84h-20.02v-9.42c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v11.77c0,2.59,2,4.71,4.71,4.71h11.77v18.84h-11.77c-2.71,0-4.71,2.12-4.71,4.71v7.06c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-7.06h20.02v16.48c0,7.77-6.36,14.13-14.13,14.13h-28.26c-7.89,0-14.13-6.36-14.13-14.13v-17.31c0-6.12,3.89-11.42,9.42-13.3-5.53-1.88-9.42-7.18-9.42-13.3v-22.02c0-7.77,6.24-14.13,14.13-14.13Z')
          path(d='M1044.32,622.6h28.26c7.77,0,14.13,6.36,14.13,14.13v14.13h-20.02v-4.71c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v18.84c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-4.71h20.02v56.51h-56.51v-18.84h36.5v-14.13c0,2.59-2.12,4.71-4.71,4.71h-17.66c-7.89,0-14.13-6.36-14.13-14.13v-37.68c0-7.77,6.24-14.13,14.13-14.13Z')
        g.weight(v-if="weight === 25 && sku !== 'IP0535-CST-Group'")
          path(d='M182,625.95l-20.7,3.5c-2.3,.3-4,2.3-4,4.6v13.4h16.5v-11.7h20v30.6h-56.4v-40c0-6.9,5.1-12.9,11.7-13.9l20.8-3.5c2.3-.3,3.8-2.3,3.8-4.6v-8.6c0-2.6-2-4.6-4.6-4.6h-7.1c-2.6,0-4.6,2.1-4.6,4.6v7.1h-20v-16.5c0-7.8,6.3-14,14-14h28.3c7.9,0,14,6.3,14,14,0,0,0,25.9,.2,25.9,0,6.8-5.1,12.7-11.9,13.7h0Z')
          path(d='M246.1,666.15h-28.3c-7.8,0-14-6.3-14-14v-14h20v4.6c0,2.6,2.1,4.6,4.6,4.6h7.1c2.6,0,4.6-2.1,4.6-4.6v-18.8c0-2.6-2-4.6-4.6-4.6h-7.1c-2.6,0-4.6,2.1-4.6,4.6v4.6h-20v-56.4h56.4v18.8h-36.5v14c0-2.6,2.1-4.6,4.6-4.6h17.7c7.9,0,14,6.3,14,14v37.7c.2,7.8-5.9,14.1-13.9,14.1h0Z')
          path(d='M1108.53,662.85l20.7-3.5c2.3-.3,4-2.3,4-4.6v-13.2h-16.5v11.7h-20v-30.6h56.4v40c0,6.9-5.1,12.9-11.7,13.9l-20.8,3.5c-2.3,.3-3.8,2.3-3.8,4.6v8.6c0,2.6,2,4.6,4.6,4.6h7.1c2.6,0,4.6-2.1,4.6-4.6v-7.1h20v16.5c0,7.8-6.3,14-14,14h-28.3c-7.9,0-14-6.3-14-14,0,0,0-25.9-.2-25.9,.1-7,5.2-12.8,11.9-13.9h0Z')
          path(d='M1044.53,622.65h28.3c7.8,0,14,6.3,14,14v14h-20v-4.6c0-2.6-2.1-4.6-4.6-4.6h-7.1c-2.6,0-4.6,2.1-4.6,4.6v18.9c0,2.6,2,4.6,4.6,4.6h7.1c2.6,0,4.6-2.1,4.6-4.6v-4.6h20v56.4h-56.4v-18.8h36.5v-14c0,2.6-2.1,4.6-4.6,4.6h-17.7c-7.9,0-14-6.3-14-14v-37.7c-.3-7.9,6-14.2,13.9-14.2h0Z')
        g.weight(v-if="weight === 10 && sku !== 'IP0535-CST-Group'")
          path(d='M160.52,666.39v-75.36h-10.01v-18.84h30.02v94.2h-20.02Z')
          path(d='M232.93,666.39h-28.26c-7.77,0-14.13-6.36-14.13-14.13v-65.94c0-7.77,6.36-14.13,14.13-14.13h28.26c7.89,0,14.13,6.36,14.13,14.13v65.94c0,7.77-6.24,14.13-14.13,14.13Zm-5.89-70.65c0-2.59-2-4.71-4.71-4.71h-7.06c-2.59,0-4.71,2.12-4.71,4.71v47.1c0,2.59,2.12,4.71,4.71,4.71h7.06c2.71,0,4.71-2.12,4.71-4.71v-47.1Z')
          path(d='M1129.97,622.55v75.36h10.01v18.84h-30.02v-94.2h20.02Z')
          path(d='M1057.55,622.55h28.26c7.77,0,14.13,6.36,14.13,14.13v65.94c0,7.77-6.36,14.13-14.13,14.13h-28.26c-7.89,0-14.13-6.36-14.13-14.13v-65.94c0-7.77,6.24-14.13,14.13-14.13Zm5.89,70.65c0,2.59,2,4.71,4.71,4.71h7.06c2.59,0,4.71-2.12,4.71-4.71v-47.1c0-2.59-2.12-4.71-4.71-4.71h-7.06c-2.71,0-4.71,2.12-4.71,4.71v47.1Z')
</template>
<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, onMounted, useTemplateRef, watch } from 'vue'
import CamoPattern from './camo-pattern.vue'
import TekPattern from './tek-pattern.vue'
import CustomBumperRenderFonts from './custom-bumper-render-fonts.vue'
import type { CustomBumperDesign } from './types'
import { PRINTER_COLORS_HEX } from '@/js/pages/product/custom/constants'
import { getSVGDimensions, renderToCanvas } from '@/js/pages/product/custom/utils'

const MAX_FONT_SIZE = 200
const MAX_TEXT_LENGTH = 26

const props = withDefaults(defineProps<{
  // The bumper config object - e.g. {text: 'my text', color: 'green'}
  config: CustomBumperDesign,
  staticImage: string,
  canvasImage?: string,
  // whether to show the template inline. Useful for debugging 3d view
  debug?: boolean,
  // 2d or 3d render
  renderType?: string,
  // Which weight numbers to show on the plate
  weight?: number,
  showRogueLogo?: boolean,
  id: string,
  sku: string,
}>(), {
  debug         : false,
  renderType    : '2d',
  weight        : 45,
  showRogueLogo : false,
})

const svgRef = useTemplateRef<SVGSVGElement>('svg')
const viewSvgRef = useTemplateRef<SVGSVGElement>('viewSvg')
const textPathRef = useTemplateRef<SVGPathElement>('textPath')
const customTextRef = useTemplateRef<SVGTextPathElement>('customText')
const customImageRef = useTemplateRef<SVGGElement>('customImage')
const customFontsRef = useTemplateRef<{ $el: HTMLDivElement }>('customFonts')

let isReadyTimeout: ReturnType<typeof setTimeout>

const color = computed(() => {
  const hex = PRINTER_COLORS_HEX[props.config.color]
  if (!hex) {
    return `url(#${props.config.color}-${props.id})`
  }

  return hex
})

const fontWeight = computed(() => (props.config.font === 'Montserrat' ? 800 : 700))

const staticImgConfig = computed(() => ({
  src    : props.staticImage,
  width  : 3000,
  height : 3000,
}))

/**
 * Update the template with the config values, and either render it to the WebGL scene or the flat image
 */
function updateRender() {
  // These refs live in the child component and may not be ready on initial page load, setting timer to run updateRender until child components are ready
  if (!svgRef.value || !viewSvgRef.value) {
    isReadyTimeout = setTimeout(() => {
      updateRender()
    }, 50)

    return
  }

  if (props.config.type === 'text') {
    const customText = customTextRef.value
    const path = textPathRef.value
    // There can still be a race condition where this function is called before the elements are showing
    if (!customText || !path || props.config.text.length > MAX_TEXT_LENGTH) {
      return
    }
    customText.setAttribute('font-family', props.config.font)
    customText.setAttribute('font-weight', fontWeight.value.toString())

    /*
    We want to find the largest font size possible.
    We will start at 250px and work our way down until we find one that fits inside the path
     */
    let fontsize = MAX_FONT_SIZE
    customText.setAttribute('font-size', fontsize.toString())
    customText.innerHTML = props.config.text.replace(/(\r\n|\n|\r)/gm, '')

    /*
    Compute the length of the path, and then the length of the text, and decreate the font size until it fits.
     */
    const pathLength = path.getTotalLength()
    while (customText.getComputedTextLength() >= pathLength) {
      fontsize -= 5
      customText.setAttribute('font-size', fontsize.toString())
    }
  } else if (props.config.type !== 'text' && customImageRef.value) {
    // Check whether we are using a design (stored in config.design) or image
    // We keep them both around so changing the tab wont erase previous uploads
    const contents = (props.config.type === 'design' ? props.config.design : props.config.image)
    const { height, width } = getSVGDimensions(contents as string)
    const isRectangular = height && width ? (width - height) > 100 : false
    const svgWidth = isRectangular ? 1000 : 1200
    const svgHeight = isRectangular ? 170 : 200
    const translateX = isRectangular ? 150 : 40
    let translateY = isRectangular ? 110 : 80
    if (props.sku === 'IP0535-CST-Group') {
      translateY += isRectangular ? 45 : 55
    }
    /*
    Since SVGs uses viewbox to scale contents, we can set the width and height of the image
    to the full printable square - and SVG will position and scale the graphic into the middle.
    Based on the template SVG, the printable area is 1200 units wide and 300 tall.
    They come in by default using our "tracing" library for PNGs, but what if the customer uploads an SVG without them?

    @todo The svg MUST have a width and height attributes for this simple replace to work.

    The Fill is then replaced with the color they want

    @todo This will only work if the SVG has all "filled" elements with black.

    A better solution here may be to create the element and traverse the tree programatically, rather than string replace.
     */
    customImageRef.value.innerHTML = props.showRogueLogo ? '' : (contents || '')
      .replace(/width="(\d+)"/, `width=${svgWidth}`)
      .replace(/height="(\d+)"/, `height=${svgHeight}`)
      .replace(/fill="black"/gi, `fill="${color.value}"`)
    customImageRef.value.setAttribute('transform', `translate(${translateX},${translateY})`)
  }

  if (props.renderType !== '3d') {
    viewSvgRef.value.innerHTML = svgRef.value.innerHTML.replace('#custom-text-path-circle', '#custom-text-path')
  }
}

async function getRender() {
  try {
    const customFontsHTML = customFontsRef.value!.$el
    viewSvgRef.value!.append(customFontsHTML)
    const canvas = await renderToCanvas(
      viewSvgRef.value!.outerHTML,
      props.canvasImage as string,
      { width: 500, height: 500 },
      { width: 375, height: 375, x: 63, y: 63 }
    )

    let svgHTML = viewSvgRef.value!.outerHTML

    if (props.sku === 'IP0535-CST-Group') {
      const removeElements = [...viewSvgRef.value!.getElementsByClassName('weight'), ...viewSvgRef.value!.getElementsByClassName('rogue-lbs')]
      for (let i = 0; i < removeElements.length; i += 1) {
        removeElements[i].remove()
      }
      svgHTML = viewSvgRef.value!.outerHTML
    }

    return { render: canvas!.toDataURL('img/jpeg', 0.8), stencil: svgHTML }
  } catch (e) {
    console.error(e)

    return ''
  }
}

// We use nextTick to give Vue time to update reactive properties in the template
watch(
  [() => props.showRogueLogo, () => props.canvasImage, () => props.sku, () => props.weight],
  () => nextTick(() => updateRender())
)

watch(() => props.config, () => nextTick(() => updateRender()), { deep: true })

onMounted(() => {
  updateRender()
})

onBeforeUnmount(() => {
  clearTimeout(isReadyTimeout)
})

defineExpose({
  getRender,
})
</script>
<style lang="scss" scoped>

.canvas {
  width: 100%;
  height: 90vh;
  overflow: hidden;
}

.view-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-svg {
  width: 75%;
  height: 75%;
}

.template {
  height: 1024px;
  width: 1024px;

  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;

  &.debug {
    background-color: black;
    position: relative;
    visibility: visible;
    opacity: 1;
    width: 100%;
    height: auto
  }

}
#custom-text {
  letter-spacing: 2px;
}
#customBumper {
  :deep() {
    .content {
      padding: 0px;
    }
  }

}

</style>
